import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

/**
 * Which direction a card is: a listing sells, an offer wants. Named in the
 * spec (§5a) and settled with the operator: "For Sale" / "Wanted" — the
 * classifieds pair. Green for sale mirrors the licence table's Auction tag,
 * so "this licence is on sale" reads the same on both screens; purple marks
 * a buyer's standing intention.
 */
const Badge = styled.span<{ $wanted: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme, $wanted }) => ($wanted ? theme.colors.purple : theme.colors.green)};
  background: ${({ theme, $wanted }) => `${$wanted ? theme.colors.purple : theme.colors.green}1a`};
  border: 1px solid ${({ theme, $wanted }) => `${$wanted ? theme.colors.purple : theme.colors.green}66`};
  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ theme, $wanted }) => ($wanted ? theme.colors.purple : theme.colors.green)};
  }
`

const TypeBadge: React.FC<{ wanted?: boolean }> = ({ wanted = false }) => {
  const { t } = useTranslation()
  return <Badge $wanted={wanted}>{wanted ? t('marketplace.typeWanted') : t('marketplace.typeForSale')}</Badge>
}

export default TypeBadge
